"use client";

import { SolutionPanel, SolutionPanels } from "daskapital-ds";

import BlockButton from "@/components/blocks/core/BlockButton/BlockButton";
import { BlocksProps } from "@/lib/wordpress/_types/blocksStyle";
import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import getBlockStyles from "@/lib/wordpress/blocks/getBlockStyles";
import { useMemo } from "react";

export type IBlockSolutionPanels = {
  attrs: {
    anchor?: string;
    className?: string;
    style?: Record<string, unknown>;
  };
  innerBlocks: BlocksProps[];
};

type ISolutionPanelAttrs = {
  label?: string;
  description?: string;
  note?: string;
  accentColor?: string;
  buttonText?: string;
  href?: {
    url?: string;
    newTab?: boolean;
  };
  mediaUrl?: string;
  mediaAlt?: string;
};

// Gutenberg omits the button text while it still equals the block default.
const DEFAULT_BUTTON_TEXT = "Know more";

export default function BlockSolutionPanels({
  attrs,
  innerBlocks,
}: IBlockSolutionPanels) {
  const { anchor, className, style } = attrs || {};

  const elStyle = useMemo(() => ({ ...getBlockStyles({ style }) }), [style]);

  return (
    <SolutionPanels id={anchor || undefined} className={className} style={elStyle}>
      {!!innerBlocks?.length &&
        innerBlocks.map((item: BlocksProps, index: number) => {
          const panel = (item?.attrs || {}) as ISolutionPanelAttrs;

          return (
            <SolutionPanel
              key={`solution-panel-${index}`}
              image={
                panel.mediaUrl ? (
                  <DisplayImage
                    url={panel.mediaUrl}
                    alt={panel.mediaAlt}
                    fill={true}
                    sizes="(min-width: 768px) 60vw, 100vw"
                  />
                ) : undefined
              }
              accentColor={panel.accentColor || undefined}
              label={panel.label}
              description={panel.description?.replace(/\n/g, "<br />")}
              note={panel.note}
              buttonElement={
                panel.href?.url ? (
                  <BlockButton
                    attrs={{
                      variant: "white",
                      text: panel.buttonText || DEFAULT_BUTTON_TEXT,
                      href: panel.href,
                    }}
                  />
                ) : undefined
              }
            />
          );
        })}
    </SolutionPanels>
  );
}
